import React from 'react'
import SupportEngineerTicketData from './SupportEngineerTicketData'

const Tickets = () => {
  const priorityLabel = (priority: number) => {
    switch (priority) {
      case 1:
        return { label: 'High', className: 'high-priority' }
      case 2:
        return { label: 'Low', className: 'low-priority' }
      case 3:
        return { label: 'Medium', className: 'medium-priority' }
      default:
        return { label: '', className: '' }
    }
  }

  const getCategoryLabel = (categoryId: number) => {
    switch (categoryId) {
      case 1:
        return 'Support'
      case 2:
        return 'Development'
      case 3:
        return 'Service'
      default:
        return ''
    }
  }

  return (
    <div>
      <SupportEngineerTicketData
        priorityLabel={priorityLabel}
        getCategoryLabel={getCategoryLabel}
      />
    </div>
  )
}

export default Tickets
